import { useVerifyIsMobile } from 'hooks/useVerifyIsMobile';
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectMetadataKeyByRegion } from 'reducers/selectors/metadata';
import './style.scss';

const LandingSlider = ({ setImgBackground, items }) => {
  const landingConfig = useSelector(
    selectMetadataKeyByRegion('landing_telmex_config'),
  );
  const [currentIndex, setCurrentIndex] = useState(0);
  const { isMobile } = useVerifyIsMobile(767);
  const secondsToTransition =
    landingConfig?.carousel_config?.seconds_to_transition || 0;

  useEffect(
    () => {
      const interval = setInterval(() => {
        setCurrentIndex(prev => (prev + 1) % items.length);
      }, secondsToTransition * 1000 + 1600);

      return () => clearInterval(interval);
    },
    [items.length],
  );

  useEffect(
    () => {
      setImgBackground(items[currentIndex].image_background_landscape);
    },
    [currentIndex, isMobile],
  );

  const getSlideClassName = itemIndex => {
    const totalItems = items.length;
    let relativePosition = (itemIndex - currentIndex + totalItems) % totalItems;

    if (relativePosition === 0) return 'landing-slider__slide__0';
    if (relativePosition === 1) return 'landing-slider__slide__1';
    if (relativePosition === 2) return 'landing-slider__slide__2';
    return 'landing-slider__slide__hide';
  };

  return (
    <div className="landing-slider">
      <div className="landing-slider__container">
        <div className="landing-slider__track">
          {items.map((slide, index) => {
            return (
              <div
                key={`slider-slide-${slide.case}`}
                className={`landing-slider__slide ${getSlideClassName(index)}`}
              >
                <img
                  src={slide.image_card_landscape}
                  alt={`Slide ${index}`}
                  className="landing-slider__image"
                />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default LandingSlider;
